import { render, staticRenderFns } from "./Create1.vue?vue&type=template&id=573e8951&scoped=true&"
import script from "./Create1.vue?vue&type=script&lang=js&"
export * from "./Create1.vue?vue&type=script&lang=js&"
import style0 from "./Create1.vue?vue&type=style&index=0&id=573e8951&prod&lang=css&"
import style1 from "./Create1.vue?vue&type=style&index=1&id=573e8951&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573e8951",
  null
  
)

export default component.exports